export default function AddMoreButton({ handleAddItem }) {
  return (
    <div className="d-flex justify-content-center">
      <button className="btn btn-secondary " onClick={handleAddItem}>
        Add More
      </button>{' '}
    </div>
  );
}
